import { useContext } from 'react';
import { UserContext } from '../components/data/context';

export default function useUserInfo() {
  return useContext(UserContext);
}
